/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 11/08/2020.
 * @module VIDEO ACTIONS
 */

import {
  SET_AUTHENTICATED,
  GET_ME,
  LOGOUT
} from "./constants";
import { createAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { createRoutine } from "redux-saga-routines";

function prepareFunc(payload) {
  return {
    meta: "",
    error: "",
    payload: {
      ...payload,
      createdAt: dayjs().format()
    }
  };
}

/**
 * Action set authenticated
 */
export const setAuthenticated = createAction(SET_AUTHENTICATED, prepareFunc);
/**
 * Action logout
 */
export const logout = createRoutine(LOGOUT, payload => ({
  ...payload,
  createdAt: dayjs()
}));
/**
 * Action get me
 */
export const getMe = createRoutine(GET_ME, payload => ({
  ...payload,
  createdAt: dayjs()
}));
